import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCirclePlaceholderOff: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="circle-placeholder-off"><path d="M3 3L21 21M7.35344 4C8.71885 3.20523 10.3063 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 13.6937 20.7948 15.2812 20 16.6466M5.14739 5.78667C3.6577 7.42864 2.75 9.60832 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C14.3744 21.25 16.5399 20.3554 18.1777 18.8848" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCirclePlaceholderOff;
